import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { PagesRoutingModule } from './pages-routing.module';
import { ThemeModule } from '../@theme/theme.module';
import { BusinessComponent } from './business/business.component';
import { BusinessEditComponent } from './shared/business-edit/business-edit.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { SidebarModule } from 'ng-sidebar';
import { UiSwitchModule } from 'ngx-ui-switch';
import {
  FormAreaComponent,
  FormCheckComponent, FormConnectedProjectsComponent,
  FormEntryComponent,
  FormListComponent,
  FormListContactComponent, FormParticipantComponent,
  FormPasswordComponent,
  FormTextComponent,
  NewsEntryComponent,
  PageContainerComponent,
} from './shared';

import { FormModuleComponent } from './shared/form-module/form-module.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NewsComponent } from './news/news.component';
import {ActivityComponent} from './activity/activity.component';

import {
  NbDialogModule,
  NbPopoverModule,
  NbProgressBarModule,
  NbToastrModule,
  NbRadioModule,
  NbCheckboxModule,
  NbSpinnerModule,
  NbCardComponent,
  NbCardModule,
} from '@nebular/theme';
import {TOASTR_CONFIG} from '../@core/config/toastr.config';
import { FormCustomerComponent } from './shared/form-customer/form-customer.component';
import { Ng2CompleterModule } from 'ng2-completer';
import { FormDateComponent } from './shared/form-date/form-date.component';
import { FormDropdownComponent } from './shared';
import { FormListContactEntryComponent } from './shared';
import { FormUploadComponent } from './shared/form-upload/form-upload.component';
import {NgxUploaderModule} from 'ngx-uploader';
import { FormListContactEntryPreviewComponent } from './shared';
import {
  FormListContactFieldRenderComponent,
} from './shared/form-list/renderer/form-list-contact-field-render.component';
import { FormListProjectComponent } from './shared/form-list-project/form-list-project.component';
import { FormListBusinessUnitComponent } from './shared/form-list-business-unit/form-list-business-unit.component';
import {FormListProjectRendererComponent} from './shared/form-list/renderer/form-list-project-renderer.component';
import {
  FormListBusinessUnitRendererComponent,
} from './shared/form-list/renderer/form-list-business-unit-renderer.component';
import {FormListCheckboxRendererComponent} from './shared/form-list/renderer/form-list-checkbox-renderer.component';
import { AdministrationRegionComponent } from './administration';
import { MaterialComponent } from './erp/material/material.component';
import { AdministrationUserComponent } from './administration';
import {TagInputModule} from 'ngx-chips';
import { FormListBusinessRendererComponent } from './shared/form-list/renderer/form-list-business-renderer.component';
import { AdministrationBusinessUnitComponent } from './administration';
import { FormRegionComponent } from './shared/form-region/form-region.component';
import { FormActivityViewComponent } from './shared/form-activity-view/form-activity-view.component';
import { FormProjectComponent } from './shared/form-project/form-project.component';
import { ProjectEditComponent } from './shared/project-edit/project-edit.component';
import { FormContactComponent } from './shared/form-contact/form-contact.component';
import {FormListActionplanComponent} from './shared/form-list/renderer/form-list-actionplan.component';
import {FormListActionplanEditComponent} from './shared/form-list/renderer/form-list-actionplan-edit.component';
import {FormListProjectTypeRenderComponent} from './shared/form-list/renderer/form-list-project-type-render.component';
import {FormListDateRendererComponent} from './shared/form-list/renderer/form-list-date-renderer.component';
import {
  FormListProjectStatusRenderComponent,
} from './shared/form-list/renderer/form-list-project-status-render.component';
import {FormListDateEditComponent} from './shared/form-list/renderer/form-list-date-edit.component';
import { TasksComponent } from './tasks/tasks.component';
import { SearchComponent } from './shared';
import {ProjectListComponent, ProjectReportComponent} from './report';
import {FormListMaterialRendererComponent} from './shared/form-list/renderer/form-list-material-renderer.component';
import { SalesReportComponent } from './report/sales-report/sales-report.component';
import { FormTagComponent } from './shared/form-tag/form-tag.component';
import { FormPercentageComponent } from './shared/form-percentage/form-percentage.component';
import {MyProjectsComponent} from './my-projects/my-projects.component';
import {FormListSortFieldRenderComponent} from './shared/form-list/renderer/form-list-sort-field-render.component';
import { MyOffersComponent } from './my-offers/my-offers.component';
import { OfferListComponent } from './report/offer-list/offer-list.component';
import { DialogCommentComponent } from './shared/dialog-comment/dialog-comment.component';
import { CommonDialogComponent } from './erp/shared/common-dialog/common-dialog.component';
import { NavigationComponent } from './erp/navigation/navigation.component';
import { CoreComponent } from './erp/core/core.component';
import { BaseProductComponent } from './erp/base-product/base-product.component';
import { FinishedProductComponent } from './erp/finished-product/finished-product.component';
import { PriceMatrixComponent } from './erp/price-matrix/price-matrix.component';
import { FormColumnSelectComponent } from './erp/shared/form-column-select/form-column-select.component';
import { DocumentComponent } from './erp/document/document.component';
import { DocFormDropdownComponent } from './erp/shared/doc-form-dropdown/doc-form-dropdown.component';
import { DocFormTextareaComponent } from './erp/shared/doc-form-textarea/doc-form-textarea.component';
import { DocFormTexfieldComponent } from './erp/shared/doc-form-texfield/doc-form-texfield.component';
import { DocFormCheckboxComponent } from './erp/shared/doc-form-checkbox/doc-form-checkbox.component';
import { DocFormDateComponent } from './erp/shared/doc-form-date/doc-form-date.component';
import { LineItemContainerComponent } from './erp/document/line-item-container/line-item-container.component';
import { DocFormFilterSelectComponent } from './erp/shared/doc-form-filter-select/doc-form-filter-select.component';
import { DocumentPrinterComponent } from './erp/document/document-printer/document-printer.component';
import { ReportsComponent } from './erp/reports/reports.component';
import { ReportsPrinterComponent } from './erp/reports/reports-printer/reports-printer.component';
import { InternalUpdatesComponent } from './erp/reports/reports-printer/internal-updates/internal-updates.component';
import { FormJsDateComponent } from './erp/shared/form-js-date/form-js-date.component';
import { CoreEditorComponent } from './erp/core/core.editor.component';
import { FormArrayFieldComponent } from './erp/shared/form-array-field/form-array-field.component';
import { DocFormRadioComponent } from './erp/shared/doc-form-radio/doc-form-radio.component';
import { PaymentPlanComponent } from './erp/document/payment-plan/payment-plan.component';
import { PackingConditionsComponent } from './erp/document/packing-conditions/packing-conditions.component';
import { LineItemMetricsComponent } from './erp/document/line-item-container/line-item-metrics/line-item-metrics.component';
import { LineItemRemainingComponent } from './erp/document/line-item-container/line-item-remaining/line-item-remaining.component';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { DocumentTreeComponent } from './erp/document/document-tree/document-tree.component';
import { DocFormAddressSelectorComponent }
  from './erp/shared/doc-form-address-selector/doc-form-address-selector.component';
import { DocStoreDropdownComponent } from './erp/shared/doc-store-dropdown/doc-store-dropdown.component';
import { DocumentMoverComponent } from './erp/document/document-select/document-mover.component';
import { CombinedShipmentComponent } from './erp/document/combined-shipment/combined-shipment.component';
import { DocumentSpoSelectorComponent } from './erp/document/document-select/document-spo-selector.component';
import { DocumentCombinedShipmentSelectorComponent }
  from './erp/document/document-select/document-combined-shipment-selector.component';
import { LineItemPfspoSelectorComponent }
  from './erp/document/line-item-container/line-item-pfspo-selector/line-item-pfspo-selector.component';
import { BarcodesComponent } from './erp/document/barcodes/barcodes.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { FormMultiSelectComponent } from './shared/form-multi-select/form-multi-select.component';
import { CustomerComponent } from './erp/reports/reports-printer/customer/customer.component';
import { UtilitiesComponent } from './erp/utilities/utilities.component';
import { CustomerChartComponent } from './erp/reports/reports-printer/customer/chart/chart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardRendererComponent } from './dashboard/renderer/renderer.component';
import { RouteForbiddenComponent } from './forbidden.component';
import { LoadingSpinnerComponent } from './shared/loading-spinner/loading-spinner.component';
import { ChangelogComponent } from './erp/shared/changelog/changelog.component';
import { DocumentCsSelectorComponent } from './erp/document/document-select/document-cs-selector.component';
import { DocumentSubComponentsComponent } from './erp/document/document-sub-components/document-sub-components.component';
import { DynamicTemplateDirective } from '../@directives/dynamic-template.directive';
import { ReportDatesComponent } from './erp/document/report-dates/report-dates.component';
import { ProductWizardComponent } from './erp/product-wizard/product-wizard.component';
import { BaseProductMatrixComponent } from './erp/price-matrix/base-product-matrix/base-product-matrix.component';
import { LineItemInfoBoxComponent } from './erp/document/line-item-container/line-item-info-box/line-item-info-box.component';
import { NbIconModule } from '@nebular/theme';
import { FormUiSwitchComponent } from './shared/form-ui-switch/form-ui-switch.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { DevHelperComponent } from './dev-helper/dev-helper.component';
import { PopupReportComponent } from './erp/reports/reports-printer/popup-report/popup-report.component';
import { PopupDocumentComponent } from './erp/document/document-printer/popup-document/popup-document.component';
import { DocumentFinishedProductSelectorComponent } from './erp/document/document-select/document-finished-product-selector.component';
import { DocFormMultiselectComponent } from './erp/shared/doc-form-multiselect/doc-form-multiselect.component';
import { DocumentOcSelectorComponent } from './erp/document/document-select/document-oc-selector.component';
import { ProjectSelectorComponent } from './erp/document/document-select/project-selector.component';
import { PfspoAvailabilityComponent } from './erp/document/line-item-container/pfspo-availability/pfspo-availability.component';
import { PfspoAvailabilityPageComponent } from './erp/document/pfspo-availability-page/pfspo-availability-page.component';
import { ActivityStatisticsComponent } from './report/activity-statistics/activity-statistics.component';
import { HtmlContainerComponent } from './shared/html-container/html-container.component';
import { BoxDetailsComponent } from './erp/document/line-item-container/box-details/box-details.component';
import { PalletLabelComponent } from './erp/document/document-printer/pallet-label/pallet-label.component';
import { CoverSheetComponent } from './erp/document/packing-conditions/cover-sheet/cover-sheet.component';
import { NrkWindowComponent } from './erp/shared/nrk-window/nrk-window.component';
import { NrkContentComponent } from './erp/shared/nrk-window/nrk-content/nrk-content.component';
import { NrkHeaderComponent } from './erp/shared/nrk-window/nrk-header/nrk-header.component';
import { NrkFooterComponent } from './erp/shared/nrk-window/nrk-footer/nrk-footer.component';
import { PackingWizardComponent } from './erp/document/packing-conditions/packing-wizard/packing-wizard.component';
import { WarehousingComponent } from './warehousing/warehousing.component';
import { DnStatusComponent } from './warehousing/dn-status/dn-status.component';
import { ThumbImageComponent } from './shared/thumb-image/thumb-image.component';
import { BoxSelectionComponent } from './erp/document/line-item-container/box-selection/box-selection.component';
import { OpenordersComponent } from './openorders/openorders.component';
import { OpenprojectsComponent } from './openprojects/openprojects.component';
import { OpeninvoicesComponent } from './openinvoices/openinvoices.component';
import { BoxLabelComponent } from './erp/document/document-printer/box-label/box-label.component';
import { QRCodeModule } from 'angularx-qrcode';
import { PfspoChartsComponent } from './erp/document/line-item-container/line-item-pfspo-selector/pfspo-charts/pfspo-charts.component';
import { MessagingComponent } from './warehousing/messaging/messaging.component';
import { NrkFixedHeaderComponent } from './erp/shared/nrk-window/nrk-fixed-header/nrk-fixed-header.component';
import { DumpViewerComponent } from './dev-helper/dump-viewer/dump-viewer.component';
import { DocumentInSelectorComponent } from './erp/document/document-select/document-in-selector.component';
import { PaymentPlanInvoicesComponent } from './erp/document/payment-plan/payment-plan-invoices/payment-plan-invoices.component';
import { OffersComponent } from './offers/offers.component';
import { QuillModule } from 'ngx-quill';
import { ProfitMarginComponent } from './erp/document/payment-plan/profit-margin/profit-margin.component';
import { DialogWizardComponent } from './erp/shared/dialog-wizard/dialog-wizard.component';
import { ProjectFinalizationComponent } from './erp/document/payment-plan/profit-margin/project-finalization/project-finalization.component';
import { WizardStepDirective } from './erp/shared/dialog-wizard/dialog-wizard.directive';
import { UnitConverterComponent } from './erp/price-matrix/unit-converter/unit-converter.component';
import { UnitSelectorRendererComponent } from './erp/price-matrix/unit-selector-renderer/unit-selector-renderer.component';
import { ProfitMarginRemarkComponent } from './erp/document/payment-plan/profit-margin/profit-margin-remark/profit-margin-remark.component';
import { OpenSrsComponent } from './opensrs/opensrs.component';
import { DocumentOfSelectorComponent } from './erp/document/document-select/document-of-selector.component';

const PAGES_COMPONENTS = [
  PagesComponent,
];

@NgModule({
    imports: [
        PagesRoutingModule,
        ThemeModule,
        Ng2SmartTableModule,
        MultiselectDropdownModule,
        SidebarModule,
        UiSwitchModule,
        NgxPaginationModule,
        Ng2CompleterModule,
        NgxUploaderModule,
        TagInputModule,
        NbIconModule,
        NbProgressBarModule,
        NbPopoverModule,
        NbToastrModule.forRoot(TOASTR_CONFIG),
        NbDateFnsDateModule.forRoot({ format: 'dd.MM.yyyy' }),
        NbDialogModule.forChild(),
        NbRadioModule,
        NbCheckboxModule,
        NbSpinnerModule,
        NgSelectModule,
        NgxBarcodeModule,
        NgxEchartsModule.forRoot({ echarts }),
        QRCodeModule,
        FormsModule,
        QuillModule.forRoot(),
        NbCardModule,
    ],
    declarations: [
        ...PAGES_COMPONENTS,
        DynamicTemplateDirective,
        NewsComponent,
        ActivityComponent,
        BusinessComponent,
        BusinessEditComponent,
        MyProjectsComponent,
        ProjectListComponent,
        FormEntryComponent,
        FormModuleComponent,
        FormCheckComponent,
        FormTextComponent,
        FormListComponent,
        FormAreaComponent,
        FormPasswordComponent,
        PageContainerComponent,
        FormListComponent,
        NewsEntryComponent,
        FormListContactComponent,
        AdministrationUserComponent,
        FormPasswordComponent,
        FormCustomerComponent,
        FormDateComponent,
        FormDropdownComponent,
        FormListContactEntryComponent,
        FormUploadComponent,
        FormListContactEntryPreviewComponent,
        FormListContactFieldRenderComponent,
        FormListProjectComponent,
        FormListBusinessUnitComponent,
        FormListProjectRendererComponent,
        FormListBusinessRendererComponent,
        FormListBusinessUnitRendererComponent,
        FormListActionplanComponent,
        FormListActionplanEditComponent,
        FormListCheckboxRendererComponent,
        FormListDateRendererComponent,
        FormListDateEditComponent,
        FormListProjectStatusRenderComponent,
        FormListProjectTypeRenderComponent,
        FormListMaterialRendererComponent,
        FormListSortFieldRenderComponent,
        FormParticipantComponent,
        FormConnectedProjectsComponent,
        AdministrationRegionComponent,
        AdministrationBusinessUnitComponent,
        MaterialComponent,
        FormRegionComponent,
        FormActivityViewComponent,
        FormProjectComponent,
        ProjectEditComponent,
        FormContactComponent,
        TasksComponent,
        SearchComponent,
        ProjectListComponent,
        MyProjectsComponent,
        SalesReportComponent,
        ProjectReportComponent,
        FormTagComponent,
        FormPercentageComponent,
        MyOffersComponent,
        OfferListComponent,
        FormConnectedProjectsComponent,
        DialogCommentComponent,
        CommonDialogComponent,
        NavigationComponent,
        CoreComponent,
        BaseProductComponent,
        FinishedProductComponent,
        PriceMatrixComponent,
        FormColumnSelectComponent,
        DocumentComponent,
        DocFormDropdownComponent,
        DocFormTextareaComponent,
        DocFormTexfieldComponent,
        DocFormCheckboxComponent,
        DocFormDateComponent,
        LineItemContainerComponent,
        DocFormFilterSelectComponent,
        DocumentPrinterComponent,
        ReportsComponent,
        ReportsPrinterComponent,
        InternalUpdatesComponent,
        FormJsDateComponent,
        CoreEditorComponent,
        FormArrayFieldComponent,
        DocFormRadioComponent,
        PaymentPlanComponent,
        PaymentPlanInvoicesComponent,
        PackingConditionsComponent,
        LineItemMetricsComponent,
        UnitConverterComponent,
        LineItemRemainingComponent,
        DocumentTreeComponent,
        DocFormAddressSelectorComponent,
        DocStoreDropdownComponent,
        DocumentMoverComponent,
        DocumentSpoSelectorComponent,
        DocumentCsSelectorComponent,
        DocumentOfSelectorComponent,
        DocumentOcSelectorComponent,
        DocumentInSelectorComponent,
        DocumentCombinedShipmentSelectorComponent,
        DocumentFinishedProductSelectorComponent,
        ProjectSelectorComponent,
        CombinedShipmentComponent,
        LineItemPfspoSelectorComponent,
        PfspoAvailabilityComponent,
        BarcodesComponent,
        FormMultiSelectComponent,
        CustomerComponent,
        UtilitiesComponent,
        CustomerChartComponent,
        DashboardComponent,
        DashboardRendererComponent,
        RouteForbiddenComponent,
        LoadingSpinnerComponent,
        ChangelogComponent,
        DocumentSubComponentsComponent,
        ReportDatesComponent,
        ProductWizardComponent,
        BaseProductMatrixComponent,
        LineItemInfoBoxComponent,
        FormUiSwitchComponent,
        DevHelperComponent,
        PopupReportComponent,
        PopupDocumentComponent,
        DocFormMultiselectComponent,
        PfspoAvailabilityPageComponent,
        ActivityStatisticsComponent,
        HtmlContainerComponent,
        BoxDetailsComponent,
        PalletLabelComponent,
        CoverSheetComponent,
        NrkWindowComponent,
        NrkContentComponent,
        NrkHeaderComponent,
        NrkFixedHeaderComponent,
        NrkFooterComponent,
        PackingWizardComponent,
        WarehousingComponent,
        DnStatusComponent,
        ThumbImageComponent,
        BoxSelectionComponent,
        OpenordersComponent,
        OpenprojectsComponent,
        OpenSrsComponent,
        OpeninvoicesComponent,
        BoxLabelComponent,
        PfspoChartsComponent,
        MessagingComponent,
        DumpViewerComponent,
        OffersComponent,
        ProfitMarginComponent,
        ProfitMarginRemarkComponent,
        DialogWizardComponent,
        ProjectFinalizationComponent,
        WizardStepDirective,
        UnitSelectorRendererComponent,
        ],
      exports: [
        NrkWindowComponent,
        NrkHeaderComponent,
        NrkContentComponent,
        FormTextComponent,
        DocFormDateComponent,
        DocFormDropdownComponent,
        DocFormFilterSelectComponent,
        DocFormTexfieldComponent,
        FormTextComponent,
        DocFormCheckboxComponent,
      ]
})

export class PagesModule {
}
